import { useState } from "react";
import { Columns2, NotebookPen } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { fmtDate } from "@/lib/checkins";
import { DiaryCompareDialog } from "./DiaryCompareDialog";
import { DiaryAverages } from "./DiaryAverages";

/** Finished diaries on the client's Progress Review tab (newest first). */
export function DiaryList({ rows, onOpen }) {
  const [comparing, setComparing] = useState(false);
  return (
    <div className="space-y-2" data-testid="checkin-diaries">
      <div className="flex items-center gap-2">
        <h3 className="flex-1 font-display text-base font-semibold text-zinc-950">Diaries</h3>
        {rows.length >= 2 && (
          <Button size="sm" variant="outline" onClick={() => setComparing(true)} data-testid="checkin-diary-compare-btn">
            <Columns2 className="mr-1.5 h-3.5 w-3.5" />Compare weeks
          </Button>
        )}
      </div>
      <DiaryAverages rows={rows} />
      {rows.map((d) => (
        <Card key={d.id} className="flex flex-wrap items-center gap-3 p-3" data-testid={`checkin-diary-${d.id}`}>
          <NotebookPen className="h-4 w-4 text-zinc-500" />
          <div className="min-w-0 flex-1">
            <div className="text-sm font-medium text-zinc-950">{fmtDate(d.period?.start)} – {fmtDate(d.period?.end)}</div>
            <div className="text-xs text-zinc-600">
              {d.entries} {d.entries === 1 ? "entry" : "entries"} · {d.days_logged} of {d.days_total} days
              {d.finalised_by === "window_closed" && " · closed automatically"}
            </div>
          </div>
          {d.flags.map((f) => <span key={f} className="rounded bg-amber-100 px-1.5 py-0.5 text-2xs font-semibold text-amber-900">{f}</span>)}
          <span className={`text-xs font-semibold ${d.reviewed_at ? "text-emerald-700" : "text-zinc-600"}`} data-testid={`checkin-diary-status-${d.id}`}>
            {d.reviewed_at ? `Reviewed by ${d.reviewed_by}` : "Awaiting review"}
          </span>
          <Button size="sm" variant="outline" onClick={() => onOpen(d.id)} data-testid={`checkin-diary-open-${d.id}`}>Open</Button>
        </Card>
      ))}
      {comparing && <DiaryCompareDialog rows={rows} onClose={() => setComparing(false)} />}
    </div>
  );
}
